import React from "react";
import Arrow from "@/assets/arrow.svg";
import S from "./Button.styled";
import { IWPLink } from "@/src/types";
import { renderIcon } from "@/src/helpers";

type Props = {
  link: IWPLink;
  type: "primary" | "secondary" | "textLink" | "smallTextLink";
  icon?: string;
  arrow?: boolean;
  color?: "dark" | "light";
};

const Button: React.FC<Props> = ({ link, type, arrow, icon, color }) => {
  return (
    <>
      {type === "primary" && (
        <S.PrimaryButton to={link.url} target={link.target}>
          {link.title && link.title}
          {icon && renderIcon(icon)}
        </S.PrimaryButton>
      )}
      {type === "secondary" && (
        <S.SecondaryButton to={link.url} target={link.target}>
          {link.title && link.title}
          {icon && renderIcon(icon)}
        </S.SecondaryButton>
      )}
      {type === "textLink" && (
        <S.TextLink to={link.url} $color={color} target={link.target}>
          {link.title && link.title}
          {arrow && <Arrow />}
        </S.TextLink>
      )}
      {type === "smallTextLink" && (
        <S.SmallTextLink to={link.url} $color={color} target={link.target}>
          {link.title && link.title}
          {arrow && <Arrow />}
        </S.SmallTextLink>
      )}
    </>
  );
};

export default Button;
